const CreateNewEventEmptyGridBoxDayView = ({i, createNewEventByClickBlankSpace, numberOfColumns}) => {
    return (
        Array.from(Array(numberOfColumns), (e, col) => (
            <div key={col} className={`col-start-${col + 1} opacity-50`} onClick={() => createNewEventByClickBlankSpace(col, i)} style={{ gridRow: `${i}/ ${i + 1}`}}></div>
        ))
    )
}
export default CreateNewEventEmptyGridBoxDayView